import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroller'
import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import WhiteBox from '../../components/WhiteBox'
import { dateTimeFormatter } from '../../utils/formatter'
import { getInvoices } from '../../reducers/invoice'
import { FETCH_INVOICES, fetchInvoices } from '../../actions/invoice'
import { createEndSelector } from '../../reducers/selector'
import TabBar from '../../components/TabBar'
import paymentIcon from '../../assets/images/payment/payment.png'

const styles = () => {
  return {
    list: {
      marginTop: '10px',
      marginLeft: '-15px',
      marginRight: '-15px',
      height: 'calc(100vh - 20vh + 20px - 10px - 70px)',
      overflowY: 'auto',
    },
    listItem: {
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    walletExpenseLabel: {
      color: 'red',
    },
    walletRedeemLabel: {
      color: 'green',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    invoices: getInvoices(state),
    isInvoicesEnd: createEndSelector([FETCH_INVOICES])(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoices(invoiceType, offset) {
      dispatch(fetchInvoices(invoiceType, offset))
    },
  }
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
class InvoiceListPage extends Component {
  state = {
    initialLoad: true,
    selectedTabIndex: 0,
  }

  get tabList() {
    const { t } = this.props
    return [
      {
        name: t('in_progress'),
        id: 'inProgress',
      },
      {
        name: t('completed'),
        id: 'completed',
      },
      {
        name: t('cancelled'),
        id: 'cancelled',
      },
    ]
  }

  get selectedTab() {
    const { selectedTabIndex } = this.state
    return this.tabList[selectedTabIndex]
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState(
      {
        selectedTabIndex,
      },
      () => {
        this.handlePullToRefresh()
      },
    )
  }

  get invoiceList() {
    const { invoices } = this.props
    return invoices[this.selectedTab.id] || []
  }

  handlePullToRefresh = () => {
    this.props.fetchInvoices(this.selectedTab.id)
  }

  handleLoadMore = () => {
    const { selectedTabIndex } = this.state
    const { invoices } = this.props
    this.props.fetchInvoices(
      this.selectedTab.id,
      (invoices[Object.keys(invoices)[selectedTabIndex]]
        && invoices[Object.keys(invoices)[selectedTabIndex]].length)
        || 0,
    )
  }

  handleInvoiceClick = (invoiceId) => {
    return () => {
      const { history, match } = this.props
      history.push(`/school/${match.params.schoolCode}/invoice/${invoiceId}`)
    }
  }

  componentDidMount() {
    this.props.fetchInvoices(this.selectedTab.id)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.initialLoad) {
      this.setState({
        initialLoad: false,
      })
    }
  }

  render() {
    const { selectedTabIndex } = this.state
    const { classes, isInvoicesEnd, t } = this.props
    return (
      <MobileWrapper overlay={true}>
        <MobileHeader title={t('payment')}>
          <TabBar
            tabs={this.tabList}
            selectedTabIndex={selectedTabIndex}
            onChange={this.handleTabChange}
          />
        </MobileHeader>
        <MobileContent scrollable={false}>
          <div className={classes.list}>
            <InfiniteScroll
              initialLoad={this.state.initialLoad}
              hasMore={!isInvoicesEnd}
              loader={<h4 key={0}>{t('loading')}</h4>}
              loadMore={this.handleLoadMore}
              useWindow={false}
            >
              {this.invoiceList.map((invoice) => {
                return (
                  <div className={classes.listItem} key={invoice.id}>
                    <WhiteBox
                      title={`${t('invoice_no')}${invoice.id}`}
                      image={paymentIcon}
                      description={dateTimeFormatter(invoice.created_at)}
                      onClick={this.handleInvoiceClick(invoice.id)}
                    />
                  </div>
                )
              })}
            </InfiniteScroll>
          </div>
        </MobileContent>
      </MobileWrapper>
    )
  }
}

InvoiceListPage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  classes: PropTypes.object,
  isInvoicesEnd: PropTypes.bool,
  invoices: PropTypes.object,
  fetchInvoices: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  t: PropTypes.func,
}

export default InvoiceListPage
